module.exports = "../img/demo-image-01.jpg";